import { render } from "./DocumentFieldActions.vue?vue&type=template&id=58bf958e&scoped=true"
import script from "./DocumentFieldActions.vue?vue&type=script&lang=js"
export * from "./DocumentFieldActions.vue?vue&type=script&lang=js"

import "./DocumentFieldActions.vue?vue&type=style&index=0&id=58bf958e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bf958e"]])

export default __exports__